import { render } from "./toppage.vue?vue&type=template&id=b1970c1c"
import script from "./toppage.vue?vue&type=script&lang=js"
export * from "./toppage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__